import { Text, View } from '@react-pdf/renderer';
import {
  ClaimsAdvice,
  isNonVesselSpecificClaimsAdvice,
  VesselSpecificClaimsAdvice,
} from '../../../models/pro.model';
import styles from '../pro-report-pdf-styles';
import NonVesselTypeSpecificLossPreventionCommentary from './pro-report-pdf-loss-prevention-commentory-components/non-vessel-type-specific-loss-prevention-commentary';
import VesselTypeSpecificLossPreventionCommentary from './pro-report-pdf-loss-prevention-commentory-components/vessel-type-specific-loss-prevention-commentary';

interface LossPreventionCommentaryProps {
  lossPreventionAdvice:
    | VesselSpecificClaimsAdvice[]
    | ClaimsAdvice[]
    | undefined
    | null;
}

function LossPreventionCommentary({
  lossPreventionAdvice,
}: LossPreventionCommentaryProps) {
  if (!lossPreventionAdvice)
    return (
      <View wrap={false} style={styles.table}>
        <Text style={styles.tableHeaderFullWidth}>
          Loss prevention commentary
        </Text>
        <Text style={styles.tableCellFullWidth}>No advice provided.</Text>
      </View>
    );

  return (
    <View>
      <View wrap={false} style={styles.table}>
        <Text style={styles.tableHeaderFullWidth}>
          Loss prevention commentary
        </Text>
      </View>
      {isNonVesselSpecificClaimsAdvice(lossPreventionAdvice) ? (
        <NonVesselTypeSpecificLossPreventionCommentary
          claimsAdvice={lossPreventionAdvice}
        />
      ) : (
        <VesselTypeSpecificLossPreventionCommentary
          vesselTypeSpecificClaimsAdvice={lossPreventionAdvice}
        />
      )}
    </View>
  );
}

export default LossPreventionCommentary;
